export default __webpack_public_path__ + "static/media/logo_kuery_blanco.ecc5ffd4.png";